import { createContext, useContext, useState, useEffect } from "react";

type Theme = "day" | "night";
const isBrowser = typeof window !== "undefined";

const ThemeContext = createContext<{ theme: Theme; toggle: () => void }>({
  theme: "day",
  toggle: () => {},
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>("day");

  useEffect(() => {
    if (!isBrowser) {
      return;
    }

    const storedTheme = localStorage.getItem("eirvana-theme");
    if (storedTheme === "day" || storedTheme === "night") {
      setTheme(storedTheme);
    }
  }, []);

  useEffect(() => {
    if (!isBrowser) {
      return;
    }

    document.documentElement.classList.toggle("night", theme === "night");
    localStorage.setItem("eirvana-theme", theme);
  }, [theme]);

  const toggle = () => setTheme(t => (t === "day" ? "night" : "day"));

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
